import { useEffect, useMemo, useState } from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const ExternUidCard = () => {
  const { entity } = useEntity();
  const configApi = useApi(configApiRef);
  const [resolved, setResolved] = useState<{ key?: string; value?: string } | undefined>();

  const hosts = useMemo(() => {
    const s = new Set<string>();
    try {
      const gi = configApi.getOptionalConfigArray('integrations.gitlab') ?? [];
      for (const c of gi) {
        const host = c.getOptionalString('host');
        if (host) s.add(host);
      }
    } catch {
      // ignore
    }
    s.add('gitlab.com');
    return s;
  }, [configApi]);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      const annotations = entity?.metadata?.annotations ?? {};
      const keys = Array.from(hosts).flatMap(h => [
        `${h}/saml-external-uid`,
        `https://${h.replace(/^https?:\/\//, '')}/saml-external-uid`,
        `http://${h.replace(/^https?:\/\//, '')}/saml-external-uid`,
      ]);
      const localKey = keys.find(k => Object.prototype.hasOwnProperty.call(annotations, k));
      const localVal = localKey ? annotations[localKey] : undefined;
      // No fallback lookup – gitlab-members namespace removed
      if (!cancelled) setResolved({ key: localKey, value: localVal });
    }
    run();
    return () => { cancelled = true; };
  }, [entity, hosts]);

  return resolved?.value ? (
    <div>
      <div style={{ fontFamily: 'monospace' }}>{resolved.value}</div>
      <div style={{ color: '#666', marginTop: 8 }}>
        Annotation: <code>{resolved.key}</code>
      </div>
    </div>
  ) : null;
};
